import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CookieConsent from "@/components/consent/CookieConsent";
import ExitIntentModal from "@/components/ExitIntentModal";

export default function Layout() {
  return (
    <>
      <a href="#main-content" className="skip-link" data-testid="skip-link">
        Skip to content
      </a>
      <Navbar />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      <ExitIntentModal />
    </>
  );
}
